import { BarChart } from '@mui/icons-material';
import React from 'react';

const Dashlet = ({ title = '', data = 0 }) => {
    return (
        <div className="card report-card mb-0">
            <div className="card-body">
                <div className="row d-flex justify-content-center">
                    <div className="col">
                        <p className="text-dark mb-1 font-weight-semibold m-0">{title}</p>
                        <h3 className="mb-0">{data}</h3>
                    </div>
                    <div className="align-self-center">
                        <div className="report-main-icon bg-light-alt">
                            <BarChart />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Dashlet;
